import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { AttritionReport } from '../../../components/reports/AttritionReport/AttritionReport';

export const AttritionReportPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle">Attrition Report</h1>
      <AttritionReport />
    </Layout>
  );
};
